import "./CommentsList.scss";
import CommentsCard from "../CommentsCard/CommentsCard";
export default function CommentsList({ commentsList }) {
  return (
    <ul className="comments-list">
      {commentsList &&
        commentsList.map((comment) => (
          <CommentsCard
            key={comment.id}
            name={comment.name}
            date={comment.timestamp}
            comment={comment.comment}
          />
        ))}
    </ul>
  );
}
